import { useEffect, useRef } from "react";
import defaultPaymentInfoServiceInstance from "../../../provider/paymentInfoService";
import useDiscountState from "../../../zustand/discountState";

declare var window: any;

export const usePageLayoutDiscount = (pageConfig: any, setOverwriteTeaser) => {

    const setShowMonthlyPrice = useDiscountState(s => s.setShowMonthlyPrice);

    const onlyVoucherOnceRef = useRef(false);

    if (onlyVoucherOnceRef.current === false) {
        onlyVoucherOnceRef.current = true;

        if (pageConfig?.discount) {
            defaultPaymentInfoServiceInstance.setVoucherSSR(pageConfig.discount);
        }
    }

    useEffect(
        () => {
            const action = async () => {
                const queryString = window.location.search;
                const urlParams = new URLSearchParams(queryString);

                const discount = urlParams.get("discount");
                const showMonthlyPrice = urlParams.get("discountShowMode");

                if (typeof window !== 'undefined') {
                    if (discount) {
                        window.discount = discount;
                    }

                    if (showMonthlyPrice === "m") {
                        setShowMonthlyPrice(true);
                    }

                    if (!window.discount && localStorage?.getItem("DISCOUNT") ) {
                        const item = JSON.parse(localStorage?.getItem("DISCOUNT"));

                        // if still valid
                        if (item.time > Date.now()) {
                            window.discount = item.discount;
                        }
                    }

                    if (!window.discount && pageConfig?.pricing?.globalDiscount) {
                        window.discount = pageConfig.pricing.globalDiscount;
                    }

                    if (pageConfig.discount?.code === window.discount) {
                        await defaultPaymentInfoServiceInstance.init(pageConfig.discount);

                        // save into local storage for 48 hours
                        localStorage?.setItem("DISCOUNT", JSON.stringify(
                            {
                                time: Date.now() + (48 * 60 * 60 * 1000),
                                discount: window.discount
                            }
                        ));
                    } else {


                        if (window.discount) {
                            let res = await defaultPaymentInfoServiceInstance.init();

                            if (res) {
                                // save into local storage for 48 hours
                                localStorage?.setItem("DISCOUNT", JSON.stringify(
                                    {
                                        time: Date.now() + (48 * 60 * 60 * 1000),
                                        discount: window.discount
                                    }
                                ));
                            } else if (pageConfig?.discount) {
                                await defaultPaymentInfoServiceInstance.init(pageConfig.discount);
                            }

                        } else {
                            // check if there is an cached teaser text
                            setOverwriteTeaser(defaultPaymentInfoServiceInstance.newTeaserText);
                        }

                    }
                }
            };

            action();
        },
        []
    );
}
